import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { MenuItem } from 'primeng/api';
import { AppServiceService } from 'src/app/app-service.service';
import { ModulesType } from 'src/app/authmanager/modules-type';
import { RoleModuleMappingService } from 'src/app/authmanager/RoleModuleMapping';
import { RoleModuleAccess } from 'src/app/product-config-admin/product-config';
import { ProductConfigAdminService } from 'src/app/product-config-admin/product-config-admin.service';
import { Customer, Unit, UserDetailsMainModel } from 'src/app/user-details-model';
import { EquipmentService } from 'src/app/user-module/modules/equipment/equipment.service';


@Component({
  selector: 'app-left-menu-admin',
  templateUrl: './left-menu-admin.component.html',
  styleUrls: ['./left-menu-admin.component.scss']
})
export class LeftMenuAdminComponent implements OnInit {
  isShown: boolean = false;
  showSubmenu = '';
  leftMenu = false;
  isShowModule: boolean;
  userDetails: UserDetailsMainModel;
  lstRolesArr: any[] = [];

  selectedCustomer: Customer;
  selectedUnit: Unit;
  menuTopPosition: number = 0;
  menuBottomPosition: any;
  menuHeight: any;
  showMenu: boolean;
  constructor(
    private appService: AppServiceService,
    private roleModuleMappingService: RoleModuleMappingService,
    public equipmentService: EquipmentService,
    private router: Router,
    private productConfigAdminService: ProductConfigAdminService,) {
  }

  ngOnInit(): void {
    this.appService.userDetails.subscribe(d => this.userDetails = d);
    this.appService.selectedCustomer.subscribe(d => this.selectedCustomer = d);
    this.appService.selectedUnit.subscribe(d => this.selectedUnit = d);
    this.getRolesAccessData();
  }
  showSubmenuFun(val) {
    if (val !== this.showSubmenu) {
      this.showSubmenu = val;
    } else {
      this.showSubmenu = '';
    }
  }
  slideToggle() {
    this.isShown = !this.isShown;
  }
  equipmentNavigation() {
    this.equipmentService.equipmentClick = false;
  }

   getRolesAccessData() {
    this.lstRolesArr = [];
    this.productConfigAdminService.getRoleModuleMapping(this.selectedCustomer.customerId).subscribe((data: RoleModuleAccess[]) => {
      if (data?.length > 0) {
        this.lstRolesArr = data;
      }
    });
  }
  LoadMenuByRole(key: any): boolean {
    let lstRoleName = this.lstRolesArr.find(role => role.roleName == this.userDetails.roles[0].roleName);   
    let requestedModuleName = this.roleModuleMappingService.GetLeftModules(key);
    return lstRoleName?.associatedModules?.some(s => s.moduleName == requestedModuleName && s.accessLevels.length > 0);
  } 
 

}

